import { Meta } from '@/src/components/common/Meta';
import JamSkillProfile from '@/src/components/game/Account/JamSkillProfile';
import { i18nKeys } from '@/src/utils/i18n.utils';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const ProfileSkillDetailsPage: React.FC = () => {
  const { t } = useTranslation();

  const pageTitle = `${t(i18nKeys.JamProfile.jamSkillProfile.title)} | ${t(i18nKeys.meta.profile.title)}`;

  return (
    <>
      <Meta title={pageTitle} />
      <JamSkillProfile />
    </>
  );
};
